import React, { useContext } from 'react'
import type { MenuItem as MenuItemData } from 'api/api.types'
import { AppLink } from 'components/Utility/AppLink/AppLink'
import { MenuContext } from './Menu'
import styles from './MenuItem.module.scss'

type MenuItemProps = {
  item: MenuItemData,
  onClick?: () => void,
}

export const MenuItem: React.FC<MenuItemProps> = (props) => {
  const { item, onClick } = props
  const { position } = useContext(MenuContext)
  const { title } = item
  const path = item.linkedPage?.fullPath ?? item.file?.link ?? item.path

  return <li onClick={onClick} className={styles.container} data-position={position}>
    <AppLink title={title} path={path} className={styles.link}>
      <span className={styles.text}>{title}</span>
    </AppLink>
  </li>
}
